import Vue from "vue";
import Router from "vue-router";
import HomeView from "../views/index/index.vue";

Vue.use(Router);

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}


const routes = [

	{
		path: "/",
		name: "index",
		component: HomeView,
		hidden: true,
		children: []
	},
];

export default new Router({
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})
export {
  routes,
}
